var map = {
	"./FORSOMEONE1087-copy.jpg": 5581,
	"./FORSOMEONE1099-copy.jpg": 1297,
	"./FORSOMEONE1103-copy.jpg": 4766,
	"./FORSOMEONE1547-copy.jpg": 7918,
	"./FORSOMEONE1699-copy.jpg": 3154,
	"./FORSOMEONE1702-copy.jpg": 974,
	"./FORSOMEONE1825-copy.jpg": 5266,
	"./FORSOMEONE2043-copy.jpg": 7387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5902;